import React, {FunctionComponent} from 'react';
import './Splash.css'
import TranslatedText from "../TranslatedText/TranslatedText";
import UITranslations from "../../../store/uiTranslations";

interface ISplash {
    additionalClass?: string
}

const Splash: FunctionComponent<ISplash> = ({additionalClass}) => {
    return (
        <section className={`Splash text-center ${additionalClass ? additionalClass : ''}`}>
            <TranslatedText source={UITranslations.SplashText}/>
            &nbsp;&nbsp;&nbsp;
            <i className="icon-spinner4 spinner"/>
        </section>
    )
};

export default Splash
